// extracted by mini-css-extract-plugin
export default {"button":"BackHomeBtn_button__RKOtd","link":"BackHomeBtn_link__GCOdj"};